import {
  Component,
  Directive,
  HostListener,
  Optional,
  Input,
  Output,
  EventEmitter
} from "@angular/core";

import { DialogRef, Dialog } from "../../../dialog.base";

@Component({
  selector: "uex-dialog-close",
  templateUrl: "./close.component.html"
})
export class DialogCloseComponent {
  @Input() public autoclose: boolean = true;
  @Output() public color: string = "dark";
  @Output("click") private _onClick: EventEmitter<void> = new EventEmitter();

  constructor(@Optional() private _dialogRef: DialogRef) {
    this._dialog = this._dialogRef.dialog;
  }

  private _dialog: Dialog;

  /**
   * @internal
   */
  public onClick(event: MouseEvent) {
    if (this._dialog && this.autoclose) this._dialog.close();
    this._onClick.emit();
  }
}

@Directive({
  selector: "[dialogClose], [dialog-close]"
})
export class DialogCloseDirective {
  constructor(@Optional() private _dialogRef: DialogRef) {
    this._dialog = this._dialogRef.dialog;
  }

  private _dialog: Dialog;

  @HostListener("click") public _onClick() {
    if (this._dialog) this._dialog.close();
  }
}
